import { c as _c } from "react/compiler-runtime";
import { Box, Grid, Skeleton } from '@mui/material';
export function MobileSkeleton(t0) {
  const $ = _c(20);
  const {
    isSpotlight
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      md: "none"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isSpotlight) {
    t2 = isSpotlight && <Grid size={12} display="flex" alignItems="center" mb={2}><Skeleton variant="rounded" width="100%" height={210} /></Grid>;
    $[1] = isSpotlight;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Grid size={12}><Skeleton variant="rounded" width="100%" height={40} /></Grid>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Grid size={12}><Skeleton variant="rounded" width={250} height={25} /></Grid>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Skeleton variant="rounded" width={150} height={90} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Grid size={12} display="flex" alignItems="center" columnGap={3} marginBottom={2}>{t5}<Box display="flex" flexDirection="column" gap={2}><Skeleton variant="rounded" width={125} height={15} /><Skeleton variant="rounded" width={125} height={15} /><Skeleton variant="rounded" width={120} height={20} /></Box></Grid>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Grid size={12}><Box flex={1} display="flex" flexDirection="column" alignItems="center" gap={2}><Skeleton variant="rounded" width="100%" height={45} /><Skeleton variant="rounded" width={250} height={15} /><Skeleton variant="rounded" width={125} height={15} /></Box></Grid>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Grid size={12} display="flex" justifyContent="space-between" alignItems="center" columnGap={3}>{[...Array(3)].map(_temp)}</Grid>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Grid size={12}><Skeleton variant="rounded" width="100%" height={70} /></Grid>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Grid size={12}><Skeleton variant="rounded" width="100%" height={60} /></Grid>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Grid size={12}><Skeleton variant="rounded" width="100%" height={50} /></Grid>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Grid size={12}><Skeleton variant="rounded" width="100%" height={50} /></Grid>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t2) {
    t13 = <Grid container={true} px={3} pt={3} pb={3} gap={3}>{t2}{t3}{t4}{t6}{t7}{t8}{t9}{t10}{t11}{t12}</Grid>;
    $[13] = t2;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Grid size={12} display="flex" borderTop="1px solid #d8d9da" py="0.75rem"><Skeleton variant="rounded" width={30} height={25} sx={{
        ml: 3,
        mr: 2
      }} /><Skeleton variant="rounded" width={250} height={25} /></Grid>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Grid size={12} display="flex" borderTop="1px solid #d8d9da" py="0.75rem"><Skeleton variant="rounded" width={30} height={25} sx={{
        ml: 3,
        mr: 2
      }} /><Skeleton variant="rounded" width={250} height={25} /></Grid>;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Grid size={12} display="flex" borderTop="1px solid #d8d9da" py="0.75rem"><Skeleton variant="rounded" width={30} height={25} sx={{
        ml: 3,
        mr: 2
      }} /><Skeleton variant="rounded" width={250} height={25} /></Grid>;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== t13) {
    t17 = <Grid border="1px solid #d8d9da" mb={3.5} borderRadius="8px" container={true} position="relative" display={t1}>{t13}{t14}{t15}{t16}</Grid>;
    $[18] = t13;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  return t17;
}
function _temp(_, idx) {
  return <Grid size={4} key={idx}><Skeleton variant="rounded" width="100%" height={90} /></Grid>;
}